/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserPriority = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High'
} as const;
export type UserPriority = typeof UserPriority[keyof typeof UserPriority];


export function UserPriorityFromJSON(json: any): UserPriority {
    return UserPriorityFromJSONTyped(json, false);
}

export function UserPriorityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPriority {
    return json as UserPriority;
}

export function UserPriorityToJSON(value?: UserPriority | null): any {
    return value as any;
}

